<template lang="pug">
.breadcrumb
    router-link.breadcrumb-item(
        v-for='(item, i) in list',
        :id='"item" + i',
        :key='i',
        :to='item.link ? item.link : ""',
        link='',
        :class='list.length == i + 1 ? "--last" : ""'
    )
        .breadcrumb-icon(v-if='item.icon')
            .icon-breadcrumb.mdi(size='18' :class='item.icon')
        .breadcrumb-label(v-if='item.label')
            a {{ item.label }}
        .breadcrumb-divisor(v-if='list.length != i + 1')
            .icon-breadcrumb.mdi.mdi-slash-forward(size='18')
</template>

<script>
export default {
    name: 'BreadcrumbComponent',

    props: {
        id: {
            type: String,
            default: () => `breadcrumb-${Math.ceil(Math.random() * 10000)}`,
        },

        list: {
            type: Array,
            default: null,
        },
    },
};
</script>

<style>
.breadcrumb {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    text-decoration: none;

    font-size: 12px;
}

.breadcrumb-item {
    display: flex;
    text-align: left;
    align-items: center;

    height: 30px;
    width: auto;
    max-width: 150px;
    padding: 4px;

    text-decoration: inherit;
    color: inherit;
}

.breadcrumb-item:hover {
    cursor: pointer;
}

.--last {
    cursor: default !important;
    font-weight: bolder;
}

.icon-breadcrumb {
    color: var(--primary-green) !important;
}
</style>